import React, { ReactNode } from "react";
import * as S from "./styled";
import { Label } from "../Typography";

type TProps = React.ComponentProps<typeof S.Card> & {
    title: ReactNode;
    children?: ReactNode;
};

const Card: React.FC<TProps> = ({ title, children, ...props }) => {
    return (
        <S.Card column spacing={0.5} {...props}>
            <S.Title>{title}</S.Title>
            <Label size="label-regular-semibold" color="text-primary-900">
                {children}
            </Label>
        </S.Card>
    );
};

export default Card;
